import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useSession } from '../contexts/SessionContext';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, isLoading, checkSession } = useSession();

  useEffect(() => {
    // Only check session if not already authenticated and not currently loading
    if (!isAuthenticated && !isLoading) {
      checkSession();
    }
  }, [location.pathname, isAuthenticated, isLoading]); // Remove checkSession from dependencies

  // Show loading spinner while verifying authentication
  if (isLoading) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute; 